export const WwwChicagotribuneComExtractor = {
  domain: 'www.chicagotribune.com',

  title: {
    selectors: [
      'h1.trb_ar_hl_t',
    ],
  },

  author: {
    selectors: [
      'span.trb_ar_by_nm_au',
    ],
  },

  date_published: {
    selectors: [
      ['meta[itemprop="datePublished"]', 'value'],
    ],
  },

  lead_image_url: {
    selectors: [
      ['meta[name="og:image"]', 'value'],
    ],
  },

  content: {
    selectors: [
      'div.trb_ar_page',
    ],

    // Is there anything in the content you selected that needs transformed
    // before it's consumable content? E.g., unusual lazy loaded images
    transforms: {
    },

    // Is there anything that is in the result that shouldn't be?
    // The clean selectors will remove anything that matches from
    // the result
    clean: [

    ],
  },
};
